import { PhoneDto } from '@/types/webapi';

export const IProfileServiceId = Symbol.for('IProfileService');

export interface IProfileService {
    /**
     * Sends phone confirmation code to provided phone number.
     * @param phone Phone object to send verification code to
     * @param recaptchaToken Recaptcha token
     */
    sendPhoneConfirmation(phone: PhoneDto, recaptchaToken: string): Promise<void>;

    /**
     * Verifies provided phone verification code.
     * @param phone
     * @param code
     */
    verifyPhoneConfirmation(phone: PhoneDto, code: string, recaptchaToken: string): Promise<boolean>;
}
